import { Fragment, useEffect } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';

import TrackUserScroll from '@/shared/components/TrackUserScroll';

import { PRECAMPAIGN_AMPLITUDE_PAGE_NAME } from '../../constants';
import type { PreCampaignProps } from '../../types';
import Faq from './sections/Faq';
import { Hero } from './sections/Hero';
import Products from './sections/Products';

const App: React.FC<React.PropsWithChildren<PreCampaignProps>> = ({
  preHero,
  seo,
  preFaq,
  preProducts,
}) => {
  const { logEvent } = useAmplitude();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  useEffect(() => {
    logEvent({
      event: 'Render Pre Campaign Landing',
      data: getSourceEventParams(),
    });
  }, []);

  return (
    <Fragment>
      <Hero {...preHero} h1={seo?.h1} />

      <TrackUserScroll
        amplitudePageName={PRECAMPAIGN_AMPLITUDE_PAGE_NAME}
        sectionName="Hero end"
      />
      <Products {...preProducts} />
      <TrackUserScroll
        amplitudePageName={PRECAMPAIGN_AMPLITUDE_PAGE_NAME}
        sectionName="Products end"
      />
      <Faq {...preFaq} />

      <TrackUserScroll
        amplitudePageName={PRECAMPAIGN_AMPLITUDE_PAGE_NAME}
        sectionName="FAQ end"
      />
    </Fragment>
  );
};

export default App;
